<template>
  <div
    class="button-sections"
    :class="'button-sections-' + panel"
    v-if="
      dataSubPanels.value[this.panel].show ||
      dataSubPanels.value[this.panel].hide
    "
  >
    <h4>
      <slot>{{ panelName }}</slot>
    </h4>
    <div class="buttons">
      <div
        class="button"
        v-for="(item, index) in getThisPanel()"
        :key="'button-' + Math.random() + '-' + index"
        @click="
          setSubPanels(item, showPanel(), index);
          clickHandler(index);
        "
        :id="panelName.replace(' ', '_') + '_' + index"
        :class="{ active: index === activeButton }"
      >
        <div class="thumb">
          <img :src="get_thumb(item)" />
        </div>
        <div class="label">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "ButtonsPanel",
  props: {
    panel: Number,
  },
  inject: ["dataSubPanels", "imagePath", "defaulImage"],
  data() {
    return {
      items: {},
      panelName: "",
      show: false,
      hide: false,
      nextPanel: this.panel + 1,
      prevPanel: this.panel - 1,
      activeItem: -1,
    };
  },
  computed: {
    activeButton() {
      return this.activeItem;
    },
  },
  methods: {
    clickHandler(idx) {
      this.activeItem = idx;
    },
    showPanel: function () {
      if (this.dataSubPanels.value[this.panel].show) {
        return this.panel + 1;
      } else {
        return this.panel - 1;
      }
    },
    setSubPanels: function (item, panel, index) {
      this.$emit("set-sub-panels", item, panel, index);
    },
    get_thumb: function (item) {
      if (!item.thumb) {
        return this.imagePath + this.defaulImage;
      } else {
        return this.imagePath + item.thumb;
      }

      // return item.thumb;
    },
    getThisPanel: function () {
      let items = this.dataSubPanels.value;

      items = items[this.panel];

      this.panelName = items.name;
      this.show = items.show;
      this.hide = items.hide;

      if (items.active >= 0) {
        this.activeItem = items.active;
      }

      return items.data;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style>
</style>
